export function fmtDate(ts) {
    if (!ts) return "—";
    const d = new Date(ts);
    return d.toLocaleString();
}

export function fmtRelative(ts) {
    if (!ts) return "—";
    const diff = Date.now() - ts;
    const s = Math.floor(diff / 1000);
    if (s < 60)     return `${s}s ago`;
    if (s < 3600)   return `${Math.floor(s/60)}m ago`;
    if (s < 86400)  return `${Math.floor(s/3600)}h ago`;
    return `${Math.floor(s/86400)}d ago`;
}

export function VerdictPill({ verdict }) {
    return <span className={`pill ${verdict}`}>{verdict}</span>;
}

export function CopyButton({ text }) {
    return (
        <button
            className="ghost"
            onClick={() => navigator.clipboard?.writeText(text ?? "")}
            title="Copy"
        >copy</button>
    );
}

export function Pager({ total, limit, offset, onChange }) {
    const page  = Math.floor(offset / limit) + 1;
    const pages = Math.max(1, Math.ceil(total / limit));
    return (
        <div className="pager">
            <div>{total.toLocaleString()} rows</div>
            <div className="row">
                <button disabled={offset === 0}      onClick={() => onChange(0)}>« first</button>
                <button disabled={offset === 0}      onClick={() => onChange(Math.max(0, offset - limit))}>‹ prev</button>
                <span>page {page} / {pages}</span>
                <button disabled={offset + limit >= total} onClick={() => onChange(offset + limit)}>next ›</button>
                <button disabled={offset + limit >= total} onClick={() => onChange((pages - 1) * limit)}>last »</button>
            </div>
        </div>
    );
}

export function ErrorBox({ children }) {
    if (!children) return null;
    return <div className="error">{children}</div>;
}

export function SuccessBox({ children }) {
    if (!children) return null;
    return <div className="success">{children}</div>;
}

export function shortHwid(s) {
    if (!s) return "—";
    return s.length > 16 ? `${s.slice(0, 8)}…${s.slice(-6)}` : s;
}
